import React, { useState, useEffect } from "react";
import { Form, Input, Upload, Button, message, Tabs, Tag } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "@/axios/axiosInstance";
import UploadAgreement from "@/components/UploadAgreement";
import "./index.scss";
import { video_bq_add } from "@/assets/jfData";
const { TextArea } = Input;
const { TabPane } = Tabs;
function isTencentVideoOrBilibili(url) {
  // 检查 URL 是否以 .mp4 结尾
  const mp4Regex = /\.mp4$/i;
  if (mp4Regex.test(url)) {
    return false;
  }

  // 检查是否为腾讯视频
  const tencentVideoRegex = /^https?:\/\/v\.qq\.com\/.+/;
  // 检查是否为 Bilibili 视频
  const bilibiliRegex = /^https?:\/\/www\.bilibili\.com\/video\/.+/;

  // 如果既不是腾讯视频也不是 Bilibili 视频，返回 true
  return !(tencentVideoRegex.test(url) || bilibiliRegex.test(url));
}
const PublishVideo = () => {
  const navigate = useNavigate(); // 获取 navigate 函数
  const [form] = Form.useForm();
  const [agreeToUpload, setAgreeToUpload] = useState(true); // 默认勾选
  const [selectedTag, setSelectedTag] = useState("1");
  const [fileList, setFileList] = useState([]);
  const [videoUrl, setVideoUrl] = useState();
  const [cover, setCover] = useState("");
  const [tabsV, setTabs] = useState("1");
  const [dataDetail, setDatali] = useState({});
  const handleTagClick = async (tag) => {
    if (selectedTag !== tag.key) {
      setSelectedTag(tag.key);
      try {
        // 调用图片接口获取对应标签的封面图
        const response = await axiosInstance.get(`/sys/image/labelImageUrl`, {
          params: {
            type: 7,
            labelType: tag.key,
          },
        });
        if (response.data.code === 10000 && response.data.data.imageUrl) {
          // 获取第一张图片的URL作为教程封面
          const coverUrl = response.data.data.imageUrl;
          setCover(coverUrl);
        }
      } catch (error) {
        console.error("Error fetching cover image:", error);
        message.error("获取封面图片失败");
      }
    }
  };

  let location = useLocation();
  let { state } = location;
  let itemId = state?.id;
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/video/account/detail?videoId=${id}`
      );
      setDatali(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchDetails(itemId); // 如果itemId存在，
    }
  }, [itemId]);

  useEffect(() => {
    // 当dataDetail更新时，更新表单的值
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        ...dataDetail,
      });
      setSelectedTag(dataDetail.label + "");
      setCover(dataDetail.cover + "");
      if (dataDetail.videoLocal) {
        setTabs("1");
        setFileList([
          {
            uid: "-1",
            name: dataDetail.fileName,
            status: "done",
            url: dataDetail.videoLocal,
          },
        ]);
      } else {
        setTabs("2");
        setVideoUrl(dataDetail.videoUrl);
      }
    }
  }, [dataDetail, form]); // 依赖dataDetail和form，以便在它们变化时重新运行
  const onFinish = (values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("introduction", values.introduction);
    formData.append("label", selectedTag);
    formData.append("cover", cover);
    let url = "/video/account/save";

    if (itemId) {
      formData.append("videoIdArray", itemId);
      url = "/video/account/update";
    }
    if (tabsV === "1") {
      if (fileList.length) {
        formData.append("videoLocal", fileList[0].url);
        formData.append("fileName", fileList[0].name);
      } else {
        message.warning("请上传视频");
        return;
      }
    } else {
      if (videoUrl) {
        if (isTencentVideoOrBilibili(videoUrl)) {
          message.warning("视频链接来自腾讯视频、B站、mp4格式");
          return;
        } else {
          formData.append("videoUrl", videoUrl);
        }
      } else {
        message.warning("请输入视频url");
        return;
      }
    }
    if (!cover) {
      message.warning("请选择视频封面");
      return;
    }
    try {
      axiosInstance
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            message.success("保存成功");
            form.resetFields();
            navigate("/personal?selectedKey=1");
          } else {
            message.error(response.data.msg);
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const tagOptions = video_bq_add.map((tag) => (
    <Tag
      color={selectedTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const changeUrl = (e) => {
    const value = e.target.value;
    setVideoUrl(value);
  };
  const onChangeTabs = (key) => {
    setTabs(key);
  };
  const onReset = () => {
    form.resetFields();
    navigate("/personal?selectedKey=1");
  };
  const handleChange = (info) => {
    let isLimit = info.fileList.length > 1;
    console.log(info);
    // 限制用户只能上传一个文件
    if (isLimit) {
      message.warning("You can only upload one file!");
    }

    // 上传成功
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
      // 这里可以添加解析和显示 PDF 的逻辑
      // 例如，你可以使用 pdf.js 来解析 PDF 文件
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }

    // 更新文件列表
    setFileList(info.fileList);
  };
  const handlePreview = (file) => {
    // 处理文件预览逻辑
    console.log(file.url);
  };
  const customUploadRequest = (options) => {
    console.log(options.file);
    const formData = new FormData();
    console.log(options);
    formData.append("file", options.file);
    // 添加其他字段或参数
    formData.append("type", 4);
    try {
      axiosInstance
        .post("/sys/image/file", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            console.log(response.data.data);
            setFileList([
              {
                uid: "-1",
                name: response.data.data.imageName,
                status: "done",
                url: response.data.data.imageUrl,
              },
            ]);
          }
        })
        .catch((error) => {
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  return (
    <Form
      form={form}
      {...formItemLayout}
      name="video_form"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="标题"
        name="title"
        rules={[{ required: true, message: "请输入标题!" }]}
      >
        <Input showCount maxLength={60} />
      </Form.Item>

      <Form.Item
        label="描述"
        name="introduction"
        rules={[{ required: true, message: "请输入描述!" }]}
      >
        <TextArea
          showCount
          style={{
            height: 200,
            resize: "none",
          }}
          maxLength={200}
        />
      </Form.Item>
      <Form.Item label="视频" name="video">
        <Tabs onChange={onChangeTabs} activeKey={tabsV}>
          <TabPane tab="上传视频" key="1">
            <Upload
              customRequest={customUploadRequest}
              // listType="picture-card"
              fileList={fileList}
              onChange={handleChange}
              onPreview={handlePreview}
            >
              {fileList.length < 1 && (
                <Button type="primary" style={{ marginRight: "40px" }}>
                  + 上传视频
                </Button>
              )}
            </Upload>
          </TabPane>
          <TabPane tab="视频地址" key="2">
            <Input
              placeholder="请输入原视频地址"
              onChange={changeUrl}
              value={videoUrl}
            />
          </TabPane>
        </Tabs>
      </Form.Item>

      <Form.Item label="视频标签" name="tags">
        <div>{tagOptions}</div>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <UploadAgreement checked={agreeToUpload} onChange={setAgreeToUpload} />
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "40px" }}
        >
          提交
        </Button>
        <Button htmlType="button" onClick={onReset}>
          取消
        </Button>
      </Form.Item>
    </Form>
  );
};
export default PublishVideo;
